
function Dipespcontrolgubernamental() {
    return(
        <div className="contenedor">
            <div className="presentacion"> 
               <h1> Presentación </h1>
               <p>
                    El Diploma de Especialización en Control Gubernamental y Control Interno 
                    brinda formación técnica y actualizada sobre el marco normativo, los 
                    mecanismos de supervisión y las herramientas de control aplicables 
                    en las entidades públicas.
               </p>
               <p>
                    El programa desarrolla contenidos vinculados al Sistema Nacional de Control, 
                    auditoría gubernamental, control simultáneo y posterior, implementación 
                    del sistema de control interno, gestión de riesgos y responsabilidades administrativas.
               </p>

                <ul>
                    <h1> Objetivo Específico </h1>
                    <ul>
                        <li>
                            Desarrollar competencias técnicas para aplicar la normativa y 
                            procedimientos del control gubernamental y del sistema de control interno, 
                            fortaleciendo la gestión institucional mediante mecanismos de prevención 
                            y mejora continua.
                        </li>
                    </ul>
                </ul>
            </div>

            <div className="metedologia">
                <img src='/uploads/curs_control_auditoria.jpg' alt='logo-de-metodologia' className='logo-metodologia'/>
                <ul> 
                    <li>
                        <h1> Informes </h1>
                        <p>Escuela de Gerencia y Gestión S.A.C</p>
                        <p>📱 913376365 / 948251685</p>
                        <p>📧 esscuelag@gmail.com | capacita@escuelag.com</p>
                    </li>
                </ul>
            </div>

            <div className="temario-principal">
                <h1> Áreas Temáticas </h1>
                <ul>
                    <li> 1. Sistema Nacional de Control </li>
                    <li> 2. Control Interno en el Sector Público </li>
                    <li> 3. Gestión de Riesgos </li>
                    <li> 4. Control Simultáneo y Posterior </li>
                    <li> 5. Responsabilidades Administrativas </li>
                </ul>
            </div>
        </div>
    );
}
export default Dipespcontrolgubernamental